import moment from "moment";
import CryptoJS from "crypto-js";
/**
 * 将ObjectArray序列化，默认以value作为key值，label作为值
 * @param {Array} arr 
 * @returns {Object} {key: value}
 */
export function arrayToObject(arr) {
  let obj = {};
  if (typeof arr === 'object' && Object.prototype.toString.call(arr) === '[object Array]') {
    arr.forEach((item, index) => {
      if (typeof item === 'object' && Object.prototype.toString.call(item) === '[object Object]') {
        if (item.hasOwnProperty('value') && item.hasOwnProperty('label')) {
          let { value, label } = item;
          obj[value] = label;
        } else {
          obj[index] = item;
        }
        return;
      }
      obj[index] = item;
    })
  }
  return obj;
}
/**
 * 将秒转为分:秒
 * @param {*} seconds 
 */
export function formatTime(seconds = 0) {
  seconds = parseInt(seconds);
  let m = Math.floor(seconds / 60);
  let s = seconds % 60;
  if (m < 10) {
    m = '0' + m;
  }
  if (s < 10) {
    s = '0' + s;
  }
  return m + ':' + s;
}
/**
 * 将秒转为时:分:秒
 * @param {*} seconds 
 */
 export function formatDuration(seconds = 0) {
  seconds = parseInt(seconds);
  let h = Math.floor(seconds / 3600);
  let s = seconds % 3600;
  let m = Math.floor(s / 60);
  s = s % 60;
  return prefixZero(h) + ':' + prefixZero(m) + ':' + prefixZero(s)
}
/**
 * 获取今天的日期
 * @returns 年-月-日
 */
export function getToday() {
  const date = new Date();
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;
  return year + '-' + month + '-' + day;
}
/**
 * GWT时间格式化
 * @param {*} date 
 */
export function formatGMTDate(dateStr) {
  if (!dateStr) {
    return '';
  }
  dateStr = new Date(dateStr);
  const year = dateStr.getFullYear();
  const month = prefixZero(dateStr.getMonth() + 1, 2);
  const date = prefixZero(dateStr.getDate(), 2);
  const hour = prefixZero(dateStr.getHours(), 2);
  const minute = prefixZero(dateStr.getMinutes(), 2);
  const seconds = prefixZero(dateStr.getSeconds(), 2);
  return `${year}-${month}-${date} ${hour}:${minute}:${seconds}`;
}
/**
 * 补0
 * @param {*} num 
 * @param {*} n 
 */
export function prefixZero(num, n = 2) {
  return (Array(n).join(0) + num).slice(-n);
}

/**
 * 下载文件
 * @param {*} fileUrl 
 * @param {*} fileName
 */
export function downloadFile(fileUrl, fileName) {
  let urlParams = fileUrl.split('/');
  const aLink = document.createElement("a");
  aLink.download = fileName || urlParams[urlParams.length  - 1];
  aLink.href = fileUrl;
  aLink.target = "_blank";
  document.body.append(aLink);
  aLink.click();
  aLink.remove();
}

/**
 * 防抖
 * @param {*} fn 
 * @param {*} time
 */
export const debounce = function (fn, time = 1000) {
  var timer = null;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn.apply(null, args);
    }, time);
  }
}

/**
 * 将search转为键值对
 * @param {*} str 
 */
 export function formatSearchParams(str) {
  let search = str;
  if (/^\?/.test(str)) {
    search = str.substring(1);
  }
  return search.split('&').reduce((obj, pre) => {
    let [key, value] = pre.split('=');
    obj[key] = value;
    return obj;
  }, {});
}

// 数组扁平化
export function flatten(arr) {
  return arr.reduce((result, item) => {
    return result.concat(Array.isArray(item) ? flatten(item) : item);
  }, []);
}
/**
 * 新窗口打开链接
 * @param {*} url 
 */
export function openNewLink(url) {
  const aLink = document.createElement("a");
  aLink.href = url;
  aLink.target = "_blank";
  document.body.append(aLink);
  aLink.click();
  aLink.remove();
}


export function checkEmptyValue(value) {
    if (value === undefined || value === null || value === '') return true;
    return false;
}
/**
 * 判断两个对象是否一样
 * @param {*} a 
 * @param {*} b 
 * @returns 
 */
export function isObjectValueEqual(a, b) {
  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i];
    let propA = a[propName];
    let propB = b[propName];
    if (typeof propA === "object") {
      if (isObjectValueEqual(propA, propB)) {
        return true;
      } else {
        return false;
      }
    } else if (propA !== propB) {
      return false;
    }
  }
  return true;
}
/**
 * 截图
 * @param {*} dom 
 * @returns base64
 */
export function getScreenShot(dom) {
  if (!dom || dom.nodeType !== Node.ELEMENT_NODE) {
    return;
  }
  const canvas = document.createElement("canvas");
  const canvasCtx = canvas.getContext("2d")
  const ratio = window.devicePixelRatio || 1;
  canvasCtx.scale(ratio, ratio);
  // canvas.width = dom.offsetWidth * ratio;
  // canvas.height = dom.offsetHeight * ratio;
  canvas.width = dom.videoWidth;
  canvas.height = dom.videoHeight;
  canvasCtx.drawImage(dom, 0, 0, canvas.width, canvas.height)
  const imgBase64 = canvas.toDataURL("image/png");
  return imgBase64;
}
/**
 * 将base64转换为blob
 * @param {*} dataurl 
 * @returns 
 */
export function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = window.atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
/**
 * 将blob转换为file
 * @param {*} theBlob 
 * @param {*} fileName 
 * @returns 
 */
export function blobToFile(theBlob, fileName) {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
}
/**
 * 将日期区间转换成开始日期的0点和结束日期的23:59:59，返回她们的时间戳
 * @param {*} rangeTime 
 */
export function formatRangeTime(rangeTime) {
  if (rangeTime && Array.isArray(rangeTime)) {
    let [startTime, endTime] = rangeTime;
    startTime = startTime ? startTime.startOf('day').format('x') : '';
    endTime = endTime ? endTime.endOf('day').format('x') : '';
    return startTime && endTime ? [startTime, endTime] : [];
  }
  return []
}

// 转换moment日期
export function getTimeStamp(date) {
  if (Array.isArray(date)) {
    return formatRangeTime(date)
  }
  if (moment.isMoment(date)) {
    return date.valueOf();
  }
  return date;
}
/**
 * 异步加载图片
 * @param {*} src 
 * @returns 
 */
export function loadImg(src) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    // 因为有些地方获取图片需要使用跨域截图，所有添加到这里
    img.setAttribute("crossOrigin", "anonymous");
    img.onload = () => resolve(img);
    img.onerror = reject;
    // src赋值在最后，这样做更加保险可以调用`load`事件。
    img.src = src;
  })
}
/**
 * 对象深层合并
 * @param {*} obj1 
 * @param {*} obj2 
 * @returns 
 */
export function deepMerge(obj1, obj2) {
  let key;
  for (key in obj2) {
    // 如果target(也就是obj1[key])存在，且是对象的话再去调用deepMerge，否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
    obj1[key] = obj1[key] && obj1[key].toString() === "[object Object]" ? deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key]);
  }
  return obj1;
}
/**
 * 深拷贝
 * @param {*} origin 
 * @returns 
 */
export function deepClone(origin) {
  let target = Array.isArray(origin) ? [] : {};
  if (typeof origin !== 'object' || origin === null) {
    return origin;
  }
  for (let prop in origin) {
    if (origin.hasOwnProperty(prop)) {
      if (typeof origin[prop] === 'object' && origin[prop] !== null) {
        target[prop] = deepClone(origin[prop]);
      } else {
        target[prop] = origin[prop];
      }
    }
  }
  return target;
}
/**
 * 获取枚举文本
 */
export function getLabel(arr, value) {
  if (Array.isArray(arr)) {
    const result = arr.find(item => String(item.value) === String(value));
    return result ? result.label : '';
  }
  return ''
}
/**
 * 读取文件的base64
 * @param {*} file 
 * @returns 
 */
export function getBase64ByFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  })
}


/**
 * 数据加密
 * @param {Object} rawData 需要加密的对象
 * @param {String} secretKey 加密的密钥。
 * @param {String} encryptMode 加密模式。从 crypto-js 的 mode 中取，默认为 ECB
 * @param {*} responseType 返回数据类型。默认为 Base64
 */
export function encrypt(rawData, secretKey = '9Uls18kTCT63vWBa', encryptMode = CryptoJS.mode.ECB) {
  const data = JSON.stringify(rawData);
  const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
      iv: '',
      mode: encryptMode,
      padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

/**
* 数据解密
* @param {String} encrypted 需要被解密的数据。
* @param {String} secretKey 解密所需的密钥
* @param {String} encryptMode 解密模式，需要和加密的模式相同。
*/
export function decrypt(encrypted, secretKey = '9Uls18kTCT63vWBa', encryptMode = CryptoJS.mode.ECB) {
  const decrypted = CryptoJS.AES.decrypt(encrypted, secretKey, {
      iv: '',
      mode: encryptMode,
      padding: CryptoJS.pad.Pkcs7
  });
  const decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}
/**
 * 生成随机字符串
 * @param {*} len 
 * @returns 
 */
export function getRandomString(len) {
  len = len || 32;
  let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  let maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

/**
 * getMonthNames(), getMonthNames('en-US', 'short'), getMonthNames('zh-CN', 'numeric')
 * [一月, 二月, 三月, 四月, 五月, 六月, 七月, 八月, 九月, 十月, 十一月, 十二月], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
 * @param {*} locale 
 * @param {*} format 
 * @returns 
 */
export function getMonthNames(locale = 'zh-CN', format = 'long') {
  const months = [];
  for (let i = 0; i < 12; i++) {
    // 创建一个日期对象，注意月份用i，日期用1（避免31日的问题），年份可以任意
    const date = new Date(new Date().getFullYear(), i, 1);
    const monthName = date.toLocaleString(locale, { month: format });
    months.push(monthName);
  }
  return months;
}